import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import MessageInterface from '../../api/MessageInterface';
import InboxMessagesProvider from '../InboxMessagesProvider';
import DynamicAction from '../../utils/DynamicAction';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import audio from '../../utils/audio';
import NotificationContext from '../../context/NotificationContext';
import { getText, TEXT_KEY } from '../../utils/localization';
/** @typedef {import('../../api/Constants').InboxMessageDetails} InboxMessageDetails */

/** @typedef {import('../../api/Constants').RewardInfo} RewardInfo */

var MessageDetails = /*#__PURE__*/function (_Component) {
  _inherits(MessageDetails, _Component);

  var _super = _createSuper(MessageDetails);

  function MessageDetails() {
    var _this;

    _classCallCheck(this, MessageDetails);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      message: undefined,
      coin: 0,
      loyalty: 0
    };

    _this._fetchMessageDetails = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var msgDetails;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return MessageInterface.getInboxMessageDetails(id);

              case 3:
                msgDetails = _context.sent;

                /** @type {RewardInfo[]} */
                msgDetails.reward_info = transformObjectArrayResponse(msgDetails.reward_info); //

                InboxMessagesProvider.readMessage(id); //

                _this.setState({
                  message: msgDetails
                });

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.sendEvent = function (messageId) {
      var coinAmount = _this.state.coin;
      var loyaltyAmount = _this.state.loyalty;
      var eventPayload = {
        id: messageId,
        coins: coinAmount.toString(),
        loyalty_points: loyaltyAmount.toString(),
        loyalty_points_before: (_this.props.loyalty - parseInt(loyaltyAmount)).toString(),
        balance_before: (_this.props.coin - parseInt(coinAmount)).toString()
      };
      Logger.sendEvent(EVENT_TYPES.INBOX_MESSAGE_ACTION_CLICKED, eventPayload);
      Logger.setActionTrigger('inboxMessage');

      if (_this.state.message.action === 'gotoStore') {
        var trigger = Logger.getActionTrigger();
        var _eventPayload = {
          balance_before: _this.props.coin.toString(),
          type: 'regular',
          trigger: trigger || ''
        };
        Logger.sendEvent(EVENT_TYPES.STORE_OPENED, _eventPayload);
      }
    };

    _this._collectRewardHandler = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var collectResponse;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                audio.onClick();
                _context2.prev = 1;
                _context2.next = 4;
                return MessageInterface.collectMessageRewards(id);

              case 4:
                collectResponse = _context2.sent;

                if (collectResponse.success) {
                  console.log('Reward Collected!');
                  collectResponse.reward_info = transformObjectArrayResponse(collectResponse.reward_info);
                  collectResponse.reward_info.map(function (reward) {
                    if (reward.currency === 'coins') {
                      _this.setState({
                        coin: reward.amount
                      });
                    }

                    if (reward.currency === 'loyalty') {
                      _this.setState({
                        loyalty: reward.amount
                      });
                    }
                  });

                  _this.sendEvent(id);

                  _this.context.addNotification({
                    message: "".concat(getText(TEXT_KEY.REWARD_COLLECTED), " ").concat(collectResponse.reward_info.map(function (reward) {
                      return "".concat(reward.amount, " ").concat(reward.currency);
                    })),
                    title: getText(TEXT_KEY.REWARD_INFO),
                    button: getText(TEXT_KEY.OK),
                    hideHelpButton: true
                  });

                  InboxMessagesProvider.removeMessage(id);
                } else {
                  _this.context.addNotification({
                    message: getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
                    title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                    button: getText(TEXT_KEY.OK)
                  });
                }

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                _this.context.addNotification({
                  message: getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
                  title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                  button: getText(TEXT_KEY.OK)
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this._dynamicActionHandler = function (action) {
      audio.onClick();
      DynamicAction.getActionCallback(action, _this.props.navigation)();
    };

    return _this;
  }

  _createClass(MessageDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.id) {
        this._fetchMessageDetails(this.props.id);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MESSAGE_ID, undefined));
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render(_objectSpread(_objectSpread({}, this.state), {}, {
        dynamicActionHandler: this._dynamicActionHandler,
        collectRewardHandler: this._collectRewardHandler
      }));
    }
  }]);

  return MessageDetails;
}(Component);

MessageDetails.contextType = NotificationContext;
export { MessageDetails as default };